import React, { Component } from 'react';
import axios from 'axios';
import socketIOClient from 'socket.io-client';
import '../styles.scss';
import { ENV, isDebug, hostname } from '../config';
import Image from '../components/Image';
import Header from '../components/Header';
import withErrorHandler from '../components/withErrorHandler';

class Home extends Component {
  constructor(props) {
    super(props);
    this.fileInput = React.createRef();

    this.state = {
      phoneNumber: '',
      files: [],
      clientId: '',
      linkSent: false,
    };
  }

  makeid = (length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i += 1) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  handleChange = (e) => {
    this.setState({ phoneNumber: e.target.value });
  };

  handleSend = async () => {
    if (!this.state.phoneNumber) return;

    try {
      await axios.post(
        '/api/send-sms',
        {
          url: `${window.location.origin}/c/${this.state.clientId}`,
          phoneNumber: this.state.phoneNumber,
        },
        // Adding a requested by header here so that we know it
        // comes from the client instead of Spectrum
        {
          headers: {
            'x-requested-by': 'webApp',
          },
        },
      );

      this.setState({ linkSent: true });

      if (isDebug) {
        console.log(`Message sent to: ${this.state.phoneNumber}`);
      }
    } catch (e) {
      this.props.handleError(e);
    }
  };

  componentDidMount = () => {
    const endpoint = window.location.origin;

    const socket = socketIOClient(
      endpoint,
      ENV === 'development' ? {} : { transports: ['websocket'] },
    );

    this.setState({ clientId: this.makeid(6) });

    socket.on('connect', () => {
      console.log('Websocket client: connected');
    });

    socket.on('photo-uploaded', (data) => {
      // eslint-disable-next-line no-shadow
      let { clientId, files } = data;

      if (this.state.clientId !== clientId) return;

      files = this.state.files.concat(files);

      this.setState({
        files,
      });
    });
  };

  getFilename = (src) => `/files/${src}`;

  renderImages = () =>
    (this.state.files || []).map((image, i) => (
      <Image src={this.getFilename(image.filename)} key={i} />
    ));

  handleUploadButton = () => {
    this.fileInput.current.click();
  };

  render() {
    return (
      <>
        <Header isHub={window.location.href.indexOf('hub.') > -1} />
        <div>
          {isDebug && (
            <div
              className="container"
              style={{
                padding: '1em',
                margin: '1em auto',
                background: '#fafafa',
                border: '1px solid #777',
              }}
            >
              [DEV] Client ID: {this.state.clientId}
            </div>
          )}

          {window.location.href.indexOf('hub.') === -1 ? (
            <div className="s404">
              <h4>Oh we weren't expecting you...</h4>
              <p>
                If this is an emergency, call <b>111</b> immediately.
              </p>
            </div>
          ) : (
            <div className="main">
              <div className="container section-mobile">
                <div className="row">
                  <div className="col-md-12">
                    <div className="alert alert-danger" role="alert">
                      You have accessed a link that is no longer active. Please request images from
                      service users using the new Spectrum process, as per the Clinician guide.
                    </div>
                  </div>
                </div>
              </div>
              <div className="container section-images">
                {!this.state.files.length > 0 && this.state.linkSent && (
                  <div className="placeholder">
                    <p>The following text has been sent to the Service User.</p>
                    <div className="sms-box">
                      Kia ora from the Triage team. Click this link to share an image with us:{' '}
                      <span>
                        {hostname}/c/{this.state.clientId}
                      </span>
                    </div>
                    <br />
                    <p>
                      Ask them to press the Share Image button, <br />
                      select their image and then press the Upload Image button.
                    </p>
                    <p>Advise them not to send identifiable images.</p>
                    <br />
                    <div className="lds-ripple">
                      <div />
                      <div />
                    </div>
                    <p>Awaiting image upload by Service User.</p>
                  </div>
                )}
                {this.state.files.length > 0 && (
                  <>
                    <h4>Click an image to rotate it.</h4>
                    <div className="image-wrapper">{this.renderImages()}</div>
                  </>
                )}
              </div>
              {this.state.linkSent && (
                <div className="container">
                  <div className="row">
                    <div className="col-md-12 instructions">
                      <br />
                      <h3>Instructions</h3>
                      <hr />
                      <h5>Saving to Spectrum</h5>
                      <ol>
                        <li>
                          Use the snipping tool to capture the image. If you cannot find it type the
                          name into the Search field.
                          <br />
                          <img alt="" src="/images/snip-01.png" />
                        </li>
                        <li>
                          Click on new and select the area of the picture by right clicking and
                          dragging the crosshair over the image.
                          <br />
                          <img alt="" src="/images/snip-02.png" />
                        </li>
                        <li>When you let go the image will appear in the snipping tool frame.</li>
                        <li>
                          Right click to copy and paste it into the Spectrum notes field.
                          <br />
                          <img alt="" src="/images/snip-03.png" />
                        </li>
                        <li>
                          <b>
                            We are using the #p as the way of searching for all patients in which an
                            image was uploaded.
                          </b>
                          Please type #p in the Notes Field, and also in the General Medical
                          History, so that it can be easily identified if the patient calls back.
                          Document like this:
                          <br />
                          <img alt="" src="/images/snip-04a.png" style={{ marginBottom: '1em' }} />
                          <img alt="" width={600} src="/images/snip-04b.png" />
                        </li>
                      </ol>
                      <br />
                      <br />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </>
    );
  }
}

export default withErrorHandler(Home);
